export default {
  pre_confirmation_message: 'You are responsible for entering correct and complete submission information. In the event of any data errors we will work with you to resolve them, but can not accept responsibility for incorrect submissions.',
  admin: true,
  continue_label: 'I have more samples',//I have more samples
  complete_label: 'Save',//Pay
  default_step: 1
};
